export default function textHide(shape) {
    shape.attr('text', '');
}
//# sourceMappingURL=text-hide.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_g2plot@1.1.24@@antv/g2plot/esm/util/responsive/rules/text-hide.js
// module id = null
// module chunks = 